export const getTransactionKey = (transaction: Record<string, any>): string => {
  const { _id, operation, shareFrom, shareTo } = transaction;
  return `${_id || operation}-${shareFrom}-${shareTo}`;
};
